<template>
  <div v-if="info.id">
    <div class="imgbanner">
      <md-swiper
        ref="swiper"
        :is-prevent="false"
        :useNative-driver="false"
      >
        <md-swiper-item :key="$index" v-for="(item, $index) in info.skus" style="display: flex;align-items: center;justify-content: center">
          <img :src="item.pic" alt="">
        </md-swiper-item>
      </md-swiper>

    </div>
    <div class="jinfenr">
      <div class="jekkrr" style="align-items: flex-start">
        <span>兑换价</span>
        <span style="color: rgba(255, 58, 48, 100)">{{ info.pointsNumber }}积分</span>
      </div>
     <div class="jekkrr" style="align-items: flex-end">
       <span>有效期</span>
       <span style="color: #101010" v-if="info.isOverdue==0">领取后{{ info.overdueDays }}天</span>
       <span style="color: #101010" v-if="info.isOverdue==1">{{info.beginTime| dateformat('YYYY-MM-DD HH:mm')}}-{{info.endTime| dateformat('YYYY-MM-DD HH:mm')}}</span>
     </div>
    </div>
    <div class="designcontainer">
      <div class="djvomnfm">
        <p class="pmkek">兑换说明</p>
        <p class="shoming">{{ info.content }}</p>
      </div>
    </div>
    <div class="duinnjfn" @click="basicDialog.open = true" v-if="info.actualStocks>0">
      <span>立即兑换</span>
    </div>
    <div class="duinnjfn krekkr"  v-if="info.actualStocks<1">
      <span>已售罄</span>
    </div>
    <md-dialog
      title="确认兑换吗？"
      :closable="false"
      v-model="basicDialog.open"
      :btns="basicDialog.btns"
    >
      积分兑换会扣除相应积分，兑换后不可撤销和退换，请仔细核对哦
    </md-dialog>
  </div>
</template>

<script>
import {Dialog, Button, Toast,Swiper, SwiperItem} from 'mand-mobile'
import {getUrlKey} from "@/until/getUrlcode";
export default {
  name: "goodeDetaile",
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
  },
  data() {
    return {
      info: {},
      id: null,
      basicDialog: {
        open: false,
        btns: [
          {
            text: '取消',
            handler: this.onBasicCancel,
          },
          {
            text: '确定',
            handler: this.duhuan,
          },
        ],
      },
      credit:{}
    }
  },
  beforeRouteLeave(to,from,next) {
    console.log(123)
    this.info={}
    next()
  },
  activated() {
    this.id = this.$route.query.id
    Toast.loading('加载中...')
    this.getPointsProductDetail(this.id,null)
  },
  methods: {
    getPointsProductDetail(id,flaf) {
      const par = {
        id: id
      }
      this.ajax.AJAx(this.ports.getPointsProductDetail, 'post', par).then(res => {
        this.info = res
        document.title = this.info.name
        this.getcreduit()
      }).catch(err => {
      })
    },
    onBasicCancel(){
      this.basicDialog.open = false
    },
    getcreduit() {
      this.ajax.AJAx(this.ports.getUserCredit, 'post').then(res => {
        this.credit = res;
        Toast.hide();
      }).catch(err => {
        Toast.hide();
      })
    },
    appdui(){
      Toast.succeed('兑换成功',3000,true);
      var that=this;
      setTimeout(function (){
        that.getPointsProductDetail(that.id,'1');
      },2000)
    },
    duhuan() {
      Toast.loading('请稍等...');
      if (this.info.actualStocks < 1) {
        Toast.failed('库存不足');
        this.basicDialog.open = false;
        return;
      }
      if (this.credit.credit < this.info.pointsNumber) {
        Toast.failed('您的积分不足');
        this.basicDialog.open = false;
        return;
      }
      const par = {
        couponModelId: this.info.couponModelId,
        id: this.info.id,
        num: 1,
        productId: this.info.productId,
        skuId: this.info.skus[0].id
      }
      this.ajax.AJAx(this.ports.changePointsProduct, 'post', par).then(res => {
        if (getUrlKey("from", window.location.href)&&getUrlKey("from", window.location.href)=='app') {
          this.basicDialog.open = false;
          this.appdui();
          HookUp.postMessage(JSON.stringify({
            code: 4
          }));
        }else{
          Toast.succeed('兑换成功',3000,true);
          localStorage.setItem('fljjr');
          this.basicDialog.open = false;
          var that=this;
          setTimeout(function (){
            that.getPointsProductDetail(that.id,null);
          },2000)
        }
      }).catch(err => {
        this.basicDialog.open = false
      })
    }

  }
}
</script>

<style scoped lang="less">
.imgbanner {
  width: 100%;
  height: 4rem;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 2.4rem;
    width: auto;
  }
}

.jinfenr {
  width: 94%;
  height: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 0.2rem;
  margin: 0.2rem 0 0.2rem 3%;
  font-size: 0.28rem;
  color: rgba(117, 117, 117, 100);
  .jekkrr{
    display: flex;
    height: 80%;
    flex-direction:column;
    justify-content: space-around;
    margin: 0 0.2rem;
  }
  span {
    margin: 0 0.2rem;
  }
}

.designcontainer {
  width: 94%;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 0.2rem;
  margin: 0.2rem 0 0.2rem 3%;
  .djvomnfm {
    width: 92%;
    margin-left: 4%;
     padding: 0.2rem 0;
    .pmkek {
      text-align: left;
      color: rgba(16, 16, 16, 100);
      font-size: 0.32rem;
      font-weight: bold;
      margin: 0.2rem 0;
    }

    .shoming {
      font-size: 0.26rem;
      color: rgba(16, 16, 16, 100);
      margin: 0;
      text-align: left;
      white-space: pre-line;
     line-height: 0.5rem;
    }

    span {
      font-size: 0.32rem;
      color: rgba(16, 16, 16, 100);
      margin: 0;
      text-align: left;
      padding-bottom: 0.12rem;
    }
  }
}

.duinnjfn {
  width: 80%;
  margin-left: 10%;
  height: 0.8rem;
  background: linear-gradient(270deg, #E8604E 0%, #E22C1C 100%);
  box-shadow: 0px 0.04rem 0.12rem -0.02rem rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.28rem;
  color: white;
  font-size: 0.28rem;
  position: fixed;
  bottom: 0.8rem;
  border-radius: 0.8rem;
}
.krekkr{
  opacity: 0.5;
}
</style>
